export enum RouteEnums {
    DASHBOARD = "dashboard",
    BeerDetails="dashboard/beer"
  }
  